<template>
  <!-- 入口和聊天窗口由容联七陌 SDK 绘制；不渲染占位元素，避免全局 span 样式使其占用页面高度。 -->
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { CUSTOMER_SERVICE_CONFIG } from "@/config/customerService";
import { buildCustomerServiceClient } from "@/utils/customerService";

const store = useStore();
const route = useRoute();
const scriptId = "customer-service-script";
let initialized = false;
let resetting = false;

const client = computed(() => {
  if (
    !CUSTOMER_SERVICE_CONFIG.enabled ||
    !store.getters.token ||
    route.path === "/login"
  )
    return null;
  return buildCustomerServiceClient(store.getters.userInfo);
});

const removeWidget = () => {
  document.getElementById(scriptId)?.remove();
  document
    .querySelectorAll(
      "#chatBtn, #qimo_chatpup, #qimo_inviteBox, #qimo_showNewMsg, #qimo_videopup, #qimo_screenpop"
    )
    .forEach((node) => node.remove());
  delete window.qimoClientId;
};

watch(
  () => JSON.stringify(client.value),
  () => {
    if (resetting) return;
    if (initialized) {
      // SDK 向 window 注册监听器、定时器，并异步加载其他脚本；仅删 DOM 无法销毁。
      // 身份失效或变更时刷新，彻底结束旧 SDK，下一次仅以当前登录账号初始化。
      resetting = true;
      removeWidget();
      window.location.reload();
      return;
    }
    if (!client.value) return;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = CUSTOMER_SERVICE_CONFIG.script;
    const source = wrapper.querySelector("script[src]");
    if (!source) return;
    const src = source.getAttribute("src");
    try {
      const url = new URL(src);
      if (
        url.protocol !== "https:" ||
        !url.pathname.endsWith("/javascripts/7moorInit.js")
      )
        return;
    } catch {
      return;
    }
    // 脚本接入使用 qimoClientId；SDK 会转换成 H5 的 clientId/otherParams 等参数。
    // 必须先设置身份再加载脚本，防止首个会话成为匿名用户。
    window.qimoClientId = client.value;
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = src;
    script.async = true;
    initialized = true;
    document.body.appendChild(script);
  },
  { immediate: true, flush: "post" }
);

onBeforeUnmount(() => {
  removeWidget();
  if (initialized && !resetting) window.location.reload();
});
</script>
